import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolEnvironments = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m6.194 14.69 1.18 1.18 3.534-3.537-3.535-3.536-1.179 1.18 2.358 2.356-2.358 2.357ZM14.5 14h-3.333v1.667H14.5V14Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.667 4A1.667 1.667 0 0 0 2 5.667V19a1.667 1.667 0 0 0 1.667 1.667h16.666A1.667 1.667 0 0 0 22 19V5.667A1.667 1.667 0 0 0 20.333 4H3.667Zm16.666 1.667H3.667V19h16.666V5.667Z",
		fill: "currentColor"
	})]
});
export default SvgToolEnvironments;
